<script setup lang="ts">
import { defineProps } from 'vue'
import type { FormItemError } from '@/services/api'

interface Props {
  errors: FormItemError[] | undefined
  haveErrors: boolean
}

const props = defineProps<Props>()
// const displayErrors = ref(props.errors)
// const showErrors = ref(props.haveErrors)
</script>
<template>
  <v-alert v-if="props.haveErrors" dense outlined type="error" class="form-error-alert">
    <ul>
      <li v-for="(error, idx) in props.errors" :key="idx" v-html="error.message"></li>
    </ul>
  </v-alert>
</template>
<style lang="scss" scoped>
.form-error-alert {
  margin-bottom: 0.5rem;
}
</style>
